import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarEmpleado = ({ show, onClose, restauranteId, onEmpleadoAgregado }) => {
    const [nuevoEmpleado, setNuevoEmpleado] = useState({
        nombre: "",
        apellido: "",
        puesto: "",
        salario: "",
        fecha_contratacion: ""
    });

    // Función para manejar el envío del formulario
    const handleAgregarEmpleado = async (e) => {
        e.preventDefault();
    
        // Validar que los campos estén completos
        if (
            nuevoEmpleado.nombre.trim() === "" ||
            nuevoEmpleado.apellido.trim() === "" ||
            nuevoEmpleado.puesto.trim() === "" ||
            nuevoEmpleado.salario.trim() === "" ||
            nuevoEmpleado.fecha_contratacion.trim() === ""
        ) {
            alert("Todos los campos son requeridos.");
            return;
        }
    
        try {            
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "empleados",
                restaurante_id: restauranteId, // Asegúrate de que este valor no sea null
                nombre: nuevoEmpleado.nombre,
                apellido: nuevoEmpleado.apellido,
                puesto: nuevoEmpleado.puesto,
                salario: nuevoEmpleado.salario,
                fecha_contratacion: nuevoEmpleado.fecha_contratacion
            });
                
            onEmpleadoAgregado(); // Llamar la función para actualizar la lista y cerrar el modal
            onClose(); // Cerrar el modal
            setNuevoEmpleado({
                nombre: "",
                apellido: "",
                puesto: "",
                salario: "",
                fecha_contratacion: ""
            }); // Resetea el formulario
        } catch (error) {
            console.error("Error al agregar empleado:", error);
            alert("Hubo un error al agregar el empleado. Intenta nuevamente.");
        }
    };
    
    

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Empleado</h2>
                <form onSubmit={handleAgregarEmpleado}>
                    <input
                        type="text"
                        value={nuevoEmpleado.nombre}
                        onChange={(e) => setNuevoEmpleado({ ...nuevoEmpleado, nombre: e.target.value })}
                        placeholder="Nombre"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={50}
                    />
                    <input
                        type="text"
                        value={nuevoEmpleado.apellido}
                        onChange={(e) => setNuevoEmpleado({ ...nuevoEmpleado, apellido: e.target.value })}
                        placeholder="Apellido"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={50}
                    />
                    <input
                        type="text"
                        value={nuevoEmpleado.puesto}
                        onChange={(e) => setNuevoEmpleado({ ...nuevoEmpleado, puesto: e.target.value })}
                        placeholder="Puesto"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={50}
                    />
                    <input
                        type="number"
                        value={nuevoEmpleado.salario}
                        onChange={(e) => setNuevoEmpleado({ ...nuevoEmpleado, salario: e.target.value })}
                        placeholder="Salario"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={20}
                    />
                    <input
                        type="date"
                        value={nuevoEmpleado.fecha_contratacion}
                        onChange={(e) => setNuevoEmpleado({ ...nuevoEmpleado, fecha_contratacion: e.target.value })}
                        placeholder="Fecha de Contratación"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <div className="flex justify-end">
                        <button type="submit" className="bg-green-500 rounded text-white px-4 py-2 mr-2">
                            Agregar
                        </button>
                        <button type="button" onClick={onClose} className="bg-gray-500 rounded text-white px-4 py-2">
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarEmpleado;
